import { render, staticRenderFns } from "./htmlOld.vue?vue&type=template&id=0ca0e38e&scoped=true"
import script from "./htmlOld.vue?vue&type=script&lang=ts"
export * from "./htmlOld.vue?vue&type=script&lang=ts"
import style0 from "./htmlOld.vue?vue&type=style&index=0&id=0ca0e38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca0e38e",
  null
  
)

export default component.exports